// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","logoAndLocations":"Navbar_logoAndLocations__tXZmK","studioDescription":"Navbar_studioDescription__NjGMI","navLinks":"Navbar_navLinks__+SFal"};